import * as alerts from '@redux/utils/alerts';
import { useEffect, useState } from 'react';
import { appIntl } from 'utility/context/IntlGlobalProvider';
import { insertUnitScriptService } from '../services';

const useInsertUnitScript = (
  execute: boolean = false,
  values: {
    unitId: number;
    script: string;
  }
): {
  submittingSave: boolean;
} => {
  const [submittingSave, setIsFetching] = useState<boolean>(false);
  useEffect(() => {
    if (values.unitId && values.script) {
      setIsFetching(true);
      insertUnitScriptService(values, {
        errorAction: () => {
          const error = {
            errorMessage: appIntl().formatMessage({ id: 'units.insertScriptFailure' }),
            errorNumber: 0
          };
          alerts.showErrorAlertFailChanges({ error });
          setIsFetching(false);
        },
        successAction: (response) => {
          if (response.success === true) {
            setIsFetching(false);
          } else {
            const error = {
              errorMessage: appIntl().formatMessage({ id: 'units.insertScriptFailure' }),
              errorNumber: 0
            };
            alerts.showErrorAlertFailChanges({ error });
            setIsFetching(false);
          }
        }
      });
    }
  }, [execute]);
  return { submittingSave };
};

export default useInsertUnitScript;
